import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CardLayer from 'components/molecules/CardLayer';
import { actionCreators as itemAC } from 'store/programItems';
import { getExercises, getExercisesFromSelectedContent } from 'store/programItems';

export type OwnPropsType = {
	programItemId: string;
	selectedContent?: any;
	selectedExerciseId?: any;
};

const mapStateToProps = (state: any, ownProps: OwnPropsType) => {
	if (typeof ownProps.selectedContent === 'object' && ownProps.selectedContent !== null) {
		return {
			exercises: getExercisesFromSelectedContent(ownProps.selectedContent),
		};
	}

	return {
		exercises: getExercises(state, ownProps.programItemId),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ ...itemAC }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardLayer as any);
